import { useEffect, useState } from 'react';
import useValidation from './Validation.js';
import {
    firstSection,
    getAnswer,
    getJumpSectionId,
    getUpcomingSectionIds,
    hasOpenGate,
    isJump,
    normalizeAnswer,
} from '../../lib/FormHelpers.js';
import { hasPaymentStep } from './Payments.js';
import { sendScrollTop } from './EmbedMessaging.js';
import { conversionTrackStep } from '~/public/lib/ConversionEventTracking.js';

const useFormSections = (sections, answers, canPay, questionRefs) => {
    const [visibleSections, setVisibleSections] = useState([]);

    const currentSectionData = sections.filter(
        s => s.section.id === visibleSections[visibleSections.length - 1],
    )[0];
    const currentSection = currentSectionData?.section;
    const currentSectionQuestions = currentSectionData?.questions;

    const { validate } = useValidation(
        currentSectionQuestions,
        answers,
        questionRefs,
    );

    const upcomingSections = getUpcomingSectionIds(
        sections,
        currentSection?.id,
        visibleSections,
    );
    const nextSection = firstSection(upcomingSections);

    useEffect(() => {
        // Make first section visible
        if (sections.length > 0) {
            setVisibleSections([sections[0].section.id]);
        }
    }, [JSON.stringify(sections)]);

    let goto = currentSection?.conditional?.goto;

    if (goto === 'condition') {
        // Change goto based on answers...
        const answerGotos = currentSection.conditional?.answerGoto || {};
        const answer = getAnswer(currentSection.conditional?.question, answers);
        console.log(
            'condition',
            answerGotos,
            answer,
            normalizeAnswer(answer),
            'q=',
            currentSection.conditional?.question,
        );
        goto = answerGotos[normalizeAnswer(answer)] || '';
        //answerGotos[Object.keys(answerGotos)[0]];
    }

    function showNextSection() {
        let gotoSection = null;

        // Validate! Just this section
        if (!validate(currentSectionQuestions, answers)) {
            return;
        }

        if (goto === 'submit') {
            // Submit! Shouldn't get here :-)
        } else if (isJump(goto)) {
            const jumpSectionId = getJumpSectionId(goto);
            const matchingSections = upcomingSections.filter(
                sid => parseInt(sid) === parseInt(jumpSectionId),
            );

            gotoSection =
                matchingSections.length > 0 ? matchingSections[0] : nextSection; // If there's no matching, just go to the next one.
            // Maybe in the future we should alert the user?
        } else {
            gotoSection = nextSection;
        }

        sendScrollTop();
        setVisibleSections([...visibleSections, gotoSection]);
    }

    useEffect(() => {
        // Track this!
        if (visibleSections.length === 0) {
            return;
        }

        conversionTrackStep(visibleSections.length, {
            sectionId: currentSection?.id,
            step: visibleSections.length,
            goto: goto,
        });
    }, [visibleSections.length]);

    const doesHavePaymentStep = hasPaymentStep(sections, answers, canPay);

    const submitIsNext = goto === 'submit' || upcomingSections.length === 0;

    // Nothing to move on to while the current section is still waiting on a
    //  gate, so the form hides its Next/Submit button until that's answered
    const isGated = hasOpenGate(currentSectionQuestions, answers);

    return {
        visibleSections,
        setVisibleSections,
        showNextSection,
        submitIsNext,
        validate,
        hasPaymentStep: doesHavePaymentStep,
        isGated,
    };
};

export default useFormSections;
